<template>
 <div style="">
     <h6>Add a New Lookbook to your Gallery</h6>
     <p><span class="sp-form-descr">(your lookbook is a collection or group of posts you want to keep together)</span></p>
        <div v-if="loading">
            <div v-if="loading" class="loading-md"></div>
            <p style="font-size:13px; color:#000000;">Preparing and Checking your Sellpoint</p>
        </div>
        <form  class="gw-form" v-else>
                <div>
                 
                    <div class="form-group">
                        <label>Lookbook Name<span class="sp-form-must">*</span></label>
                        <input type="text" v-model="gallery.gallery_name" value="" placeholder="What's the Name of your Lookbook">
                    </div>

                    <div class="form-group">
                        <label>Description<span class="sp-form-must">*</span></label>
                        <textarea  v-model="gallery.gallery_description" placeholder="What's this Lookbook all about"></textarea>
                     </div>
                   
                </div>
                <h6>Add a Post to <span style="color:#ff0055;">{{gallery.gallery_name}}</span> Lookbook</h6>
                <p><span class="sp-form-descr">(This would be the first post added to this lookbook)</span>
                </p>
                <div>
                    <div>
                    
                        <div class="form-group">
                            <label>Caption<span class="sp-form-must">*</span></label>
                            <input type="text" v-model="post.post_caption"  placeholder="Caption/Title this Post">
                        </div>
                        
                    
                        <div class="form-group">
                            <label>Details<span class="sp-form-must">*</span>  </label>
                            <textarea  v-model="post.post_details"  placeholder="Full Post Details"></textarea>
                           
                        </div>
                        <!-- <h6>Add a product Item, you can add more items later</h6> -->

                        
                        
                        <div class="">
                            <div class="upload-btn-wrapper" >
                                <!-- <img class="img_responsive"/> -->
                                <button class="upload-btn" type="button">Add Post's media (Image/Video)</button>
                                <input type="file" @change="onFileChange($event)" accept="image/*,video/*" capture/>
                                <span v-if="file_info[0]"><b>Added {{file_info[0].name}}</b></span>                                                                                                                                                                                                                                                                                                                                        
                            </div>
                            <div><span class="sp-form-descr">(You can always add more images or video on this post)</span></div>
                        </div>
                        <div class="form-group">
                            <p style="color:#ff0000">{{data_error_message}}</p>
                            <p style="color:#ee87a6">{{data_success_message}}</p>
                            <div v-if="action_loading" class="loading-sm"></div>
                            <button :disabled="disable_btn" type="button" class="btn" style="background:#ff0055; color:#ffffff;" @click="addGallery">All Done, Add Lookbook</button>
                        </div>
                    </div>
                    <hr/>
                </div>
        </form>
        
    </div>
</template>
<style>

</style>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'ProductForm',
    data () {
        return {
            user:{},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            products:{},
            post:{},
            gallery:{},
            product_item: {},
            disable_btn: false,
            loading:true,
            action_loading:false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            data_success_message: "",
            data_error_message:"",
        }
    },
    components: {
       
     },
    methods: {

        setComponent(attr1,attr2){
            
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        
        trackevent(e){
            // $('#category-type-3').disabled = true;
            if(e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined){
              this.category_type_2 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined){
              this.category_type_1 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined){
              this.category_type_1 = true;
              this.category_type_2 = true; 
            }
            else{
            this.category_type_1 = false;
              this.category_type_2 = false;
              this.category_type_3 = false;
             }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        //get sellpoint categories
                        this.getSellpointCategories();
                        

                    }else {
                        this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

        getSellpointCategories(){
            service.getBusinessByUserName(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                   this.sellpoint = response.body.data;
                   this.loading = false;
                   //not needed for now
                    // service.getBusinessCategories(this, this.sellpoint.business_id).then(response => {
                    //     if(response.body.status == 200) {
                    //         this.sellpoint_categories = response.body.data;
                    //     }
                    // }).catch((err) => {})
                    // this.getSubCategories(this.sellpoint.business_category_id);
                   // this.getSellpointProducts();
                }
            }).catch((err) => {
                //if err, recall this function
                this.getSellpointCategories();
                //log it
               // this.$router.push("/")
             //  console.log(err)
            })

        },

        getSubCategories(category){
            service.getBusinessSubCategories(this, category).then(response => {
                if(response.body.status == 200) {
                    this.sub_categories = response.body.data;
                }
            }).catch((err) => {})
                
        },

        getSellpointProducts(){
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                }
            }).catch((err) => {})
                
        },

        addGallery(){
            this.activate_processing();
            var credentials = {
                gallery_new_group: true,
                gallery_group_type: 1, //default post gallery
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description:this.gallery.gallery_description,
                gallery_post_group: 0, //no group as in new
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products:  [], 
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        //toastr.success("Post Created", 'Success!');
                        this.data_success_message = "processing, please wait.. ..";
                        //log user in
                        this.post = data.body.data;
                        
                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type","gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                        if(data.body.status == 200){
                            //this.product.product_image = data.body.data;
                            location.reload(true);
                            //this.product_info = true;
                            //this.product_url = "/"+this.$route.params.id+"/"+this.product.product_url_name;
                        }
                        }).catch((err) => {
                                if(err) {
                                // log it
                               // console.log(err)
                                }
                            //toastr.warning("Something went wrong.", 'Warning!');
                             this.data_error_message = "Something went wrong..";
                        })

                        //if uploading takes time continue with reload
                        let self = this;
                        setTimeout(function(){  location.reload(true); }, 2000); //wait for 1min and call posts in gallery

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner
                        //this.deactivate_processing();///....don't deactivate here since media may still be loading
                        
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.warning("Something went wrong", 'Warning!'); 
                       // console.log(err)
                        // this.disable_btn = false;
                        this.deactivate_processing();
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },

   

    //uploads
    onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (files.length)
        {   
            this.file_info = files;
            let formData = new FormData();
            formData.append('photo', files[0]); 
            this.imageForm = formData;
        }   
       
    },

},
    created: function(){
        this.preset();
    }
}

</script>


// WEBPACK FOOTER //
// newgallery.vue?6a232bb3